import { schema } from 'normalizr';

export const phraseTRSchema = new schema.Entity('phraseTRs', {}, { idAttribute: 'PhraseTRId' });

export const phraseTRListSchema = [phraseTRSchema];
